import React, { useState, useEffect } from "react";
import API from "../../api/axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import Layout from "../layout/Layout";
import { Link, useNavigate } from "react-router-dom";
import "./TeamTableModern.css";

export default function TeamTable() {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMember, setViewMember] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const closeModal = () => setViewMember(null);

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;
  const navigate = useNavigate();

  const fetchTeamMembers = async () => {
    if (!userId) return;
    try {
      setLoading(true);
      const res = await API.get(`/team/all/${userId}`);
      setTeamMembers(res.data.teamMembers || []);
    } catch {
      toast.error("Failed to fetch team members");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeamMembers();
  }, [userId]);

const handleDelete = async (id) => {
  const result = await Swal.fire({
    title: "Delete Team Member?",
    text: "This action cannot be undone.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, Delete",
    cancelButtonText: "Cancel",
  });

  if (!result.isConfirmed) return;

  try {
    await API.delete(`/team/delete/${userId}/${id}`);

    Swal.fire({
      icon: "success",
      title: "Deleted!",
      text: "Team member has been deleted successfully.",
      timer: 1500,
      showConfirmButton: false,
    });

    fetchTeamMembers();
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Delete Failed",
      text: "Unable to delete team member.",
    });
  }
};

  const handleEdit = (member) => {
    navigate("/Team-meb", { state: { memberToEdit: member } });
  };

  const filteredMembers = teamMembers.filter((m) => {
    const term = searchTerm.toLowerCase();
    return (
      m.name?.toLowerCase().includes(term) ||
      m.email?.toLowerCase().includes(term) ||
      m.mobile?.toString().includes(term)
    );
  });

  return (
    <Layout>
      <ToastContainer />
      <div className="container py-4">

        {/* HEADER */}
        <div className="header">
          <h3>Team Members</h3>
          <Link to="/Team-meb" className="add-btn">+ Add Member</Link>
        </div>

        {/* SEARCH */}
        <input
          type="text"
          placeholder="Search name, email, mobile..."
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {/* LOADING */}
        {loading ? (
          <div className="loader"></div>
        ) : filteredMembers.length === 0 ? (
          <p className="text-center mt-4">No members found</p>
        ) : (
          <>
            {/* DESKTOP TABLE */}
            <div className="desktop-view">
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>Photo</th>
                    <th>Name</th>
                    <th>Company</th>
                   
                    <th>Mobile</th>
                    <th>Email</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMembers.map((m) => (
                    <tr key={m._id}>
                      <td>
                        {m.photo ? (
                          <img src={m.photo} className="photo" alt="" />
                        ) : (
                          <div className="photo-placeholder">
                            {m.name?.charAt(0)}
                          </div>
                        )}
                      </td>
                      <td>{m.name}</td>
                      <td>{m.companyName}</td>
                   
                      <td>{m.mobile}</td>
                      <td>{m.email}</td>
                      <td>
                        <button onClick={() => setViewMember(m)}>View</button>
                        <button onClick={() => handleEdit(m)}>Edit</button>
                        <button onClick={() => handleDelete(m._id)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* MOBILE CARDS */}
            <div className="mobile-view">
              {filteredMembers.map((m) => (
                <div key={m._id} className="card">

                  <div className="card-top">
                    <div className="profile">
                      {m.photo ? (
                        <img src={m.photo} alt="" />
                      ) : (
                        <span>{m.name?.charAt(0)}</span>
                      )}
                    </div>
                    <div>
                      <h4>{m.name}</h4>
                      <p>{m.companyName}</p>
                    </div>
                  </div>

                  <div className="card-body">
                    <p>📍 {m.currentLocation}</p>
                    <p>📞 {m.mobile}</p>
                    <p>✉️ {m.email}</p>
                  </div>

                  <div className="card-actions">
                    <button onClick={() => setViewMember(m)}>View</button>
                    <button onClick={() => handleEdit(m)}>Edit</button>
                    <button onClick={() => handleDelete(m._id)}>Delete</button>
                  </div>

                </div>
              ))}
            </div>
          </>
        )}

        {/* MODAL */}
{viewMember && (
  <div className="modal-overlay" onClick={closeModal}>
    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
      <button className="close-icon" onClick={closeModal}>
        ×
      </button>

  

      {/* HEADER */}
      <div className="modal-header">
        
        <div className="profile-img">
          <img
            src={
              viewMember.photo ||
              `https://ui-avatars.com/api/?name=${viewMember.name}`
            }
            alt={viewMember.name}
          />
        </div>

        <h3 className="member-name">{viewMember.name}</h3>
       
      </div>

      {/* BODY */}
      <div className="modal-body">

        <div className="info-grid">
           <div><strong>Ccompany Name</strong><span>{viewMember.companyName}</span></div>
             <div><strong>Current Location</strong><span>{viewMember.currentLocation}</span></div>
          <div><strong>Current Location</strong><span>{viewMember.currentLocation}</span></div>
          <div><strong>Service Location</strong><span>{viewMember.serviceLocation}</span></div>
          <div><strong>Which Location</strong><span>{viewMember.whichLocation}</span></div>
          <div><strong>Upline</strong><span>{viewMember.upline}</span></div>
          <div><strong>Upline Name</strong><span>{viewMember.uplineName}</span></div>
          <div><strong>Upline Code</strong><span>{viewMember.uplineCode}</span></div>
          <div><strong>SAO Name</strong><span>{viewMember.saoName}</span></div>
          <div><strong>SAO Code</strong><span>{viewMember.saoCode}</span></div>
          <div><strong>SGO Name</strong><span>{viewMember.sgoName}</span></div>
          <div><strong>SGO Code</strong><span>{viewMember.sgoCode}</span></div>

        </div>

        <div className="ref-section">
          <strong>Referred By</strong>
          <p>{viewMember.referredBy}</p>
        </div>

      </div>

      {/* FOOTER */}
      <div className="modal-footer">
        <button onClick={closeModal}>Close</button>
      </div>

    </div>
  </div>
)}

      </div>
    </Layout>
  );
}